import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from '../../../store';
import { IFeaturedItem } from '../../../models/featurered-item';
import { loadFeaturedItems } from '../../../store/e-store/featured-item-actions';
import Gallery from '../../common/gallery';
import FeaturedItemElement from './featured-item-element';
import { IProductAvailabilityItem } from '../../../../../../../Application/TypewriterModels/IProductAvailabilityItem';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../hooks/redux-hooks';

interface IFeaturedGalleryProps {
    productAvailabilityData?: IProductAvailabilityItem[];
}

const responsive = {
    0: { items: 1 },
    1024: { items: 2 },
};

export const FeaturedItemGallery = ({
    productAvailabilityData,
}: IFeaturedGalleryProps) => {
    const intl = useIntl();
    const dispatch = useAppDispatch();

    const featuredItems = useSelector((state: RootState) =>
        state.featuredItems ? state.featuredItems.data! : []
    );

    useEffect(() => {
        if (featuredItems.length === 0) {
            dispatch(loadFeaturedItems());
        }
    }, []);

    const isProductAvailabilityActive = (): boolean =>
        productAvailabilityData !== undefined &&
        productAvailabilityData.length > 1;

    return (
        <div className="featured-items">
            {featuredItems.length > 0 && (
                <Gallery
                    title={
                        !isProductAvailabilityActive()
                            ? intl.formatMessage({
                                  id: 'Featured',
                                  defaultMessage: 'Featured',
                              })
                            : undefined
                    }
                    titleIcon={
                        !isProductAvailabilityActive()
                            ? 'far fa-lightbulb'
                            : undefined
                    }
                    marginBottom={60}
                    responsive={responsive}
                    items={featuredItems.map((item, index) => {
                        return (
                            <FeaturedItemElement
                                key={index}
                                isNew={item.isNew}
                                title={item.title}
                                imageUrl={item.imageUrl}
                                imageAltText={item.imageAltText}
                                callToActionLabel={item.callToActionLabel}
                                callToActionUrl={item.callToActionUrl}
                                target={item.callToActionTarget}
                            />
                        );
                    })}
                />
            )}
        </div>
    );
};

export default FeaturedItemGallery;
